/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Antragvollstaendigversendet2Inputs */

const de__field_antragvollstaendigversendet2 = /** @type {(inputs: _Field_Antragvollstaendigversendet2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antrag vollständig versendet`)
};

/**

* @param {_Field_Antragvollstaendigversendet2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_antragvollstaendigversendet2 = /** @type {((inputs?: _Field_Antragvollstaendigversendet2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Antragvollstaendigversendet2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_antragvollstaendigversendet2(inputs)
});
export { _field_antragvollstaendigversendet2 as "_field_antragVollstaendigVersendet" }